import { Grid, Paper, Typography } from "@mui/material";
import Return from "./Return/Return";
import Report from "./Report/Report";
import Request from "./Request/Request";
import { createContext, useState } from "react";
import { LoadingAnimation } from "./LoadingAnimation/LoadingAnimation";
import { ActionResponseModal } from "./ActionResponseModal/ActionResponseModal";
import ChatIcon from "@mui/icons-material/Chat";

export const ActionStatusContext = createContext({
  setIsLoading: (value: boolean) => {},
  showActionResponse: () => {},
  setIsActionSuccess: (value: boolean) => {},
});

export default function Actions() {
  const [isLoading, setIsLoading] = useState(false);
  const [showActionResponse, setShowActionResponse] = useState(false);
  const [isActionSuccess, setIsActionSuccess] = useState(true);
  return (
    <ActionStatusContext.Provider
      value={{
        setIsLoading: setIsLoading,
        showActionResponse: () => setShowActionResponse(true),
        setIsActionSuccess: setIsActionSuccess,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant={"h3"} color={"primary.main"}>
            Actions
          </Typography>
          <div className="hardware-assistant">
            <a
              className="link-style"
              href={
                "https://notebooklm.google.com/notebook/867e2ac4-48cc-46ba-bcb5-c0ff605f63fb"
              }
              target={"_blank"}
            >
              <ChatIcon className="icon-margin" /> Hardware Assistant
            </a>
            <div className={"new-tail"}>New</div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <Paper sx={{ p: 2 }}>
            <Report />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <Paper sx={{ p: 2 }}>
            <Request />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <Paper sx={{ p: 2 }}>
            <Return />
          </Paper>
        </Grid>
      </Grid>
      <LoadingAnimation isOpen={isLoading} />
      <ActionResponseModal
        isSuccess={isActionSuccess}
        isOpen={showActionResponse}
        onClose={() => setShowActionResponse(false)}
      />
    </ActionStatusContext.Provider>
  );
}
